"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const api_1 = require("../../../@shared-types/api");
let TranslationService = class TranslationService {
    constructor() {
        this.translateExportAPI = (api) => {
            switch (api) {
                case api_1.EExportAPI.MOBILE_SELLER: return 'Mobile.de';
                case api_1.EExportAPI.AUTOSCOUT24: return 'AutoScout24';
                case api_1.EExportAPI.AWI: return 'Händler-Website';
                default: return '';
            }
        };
    }
};
TranslationService = __decorate([
    (0, core_1.Injectable)()
], TranslationService);
exports.default = TranslationService;
